"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftAPI = void 0;
var api_client_1 = __importDefault(require("../api-client"));
var nft_constants_1 = require("./nft.constants");
var NftAPI = /** @class */ (function () {
    function NftAPI() {
    }
    NftAPI.create = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.CREATE_NFT, payload)];
            });
        });
    };
    NftAPI.search = function (data) {
        return api_client_1.default.post(nft_constants_1.NFT_API_URLS.SEARCH, data);
    };
    NftAPI.fetchMyNFTs = function (data) {
        return api_client_1.default.post(nft_constants_1.NFT_API_URLS.LIST_MY, data);
    };
    NftAPI.fetchCreatedNFTs = function (data) {
        return api_client_1.default.post(nft_constants_1.NFT_API_URLS.LIST_CREATED, data);
    };
    NftAPI.fetchCollectedNFTs = function (data) {
        return api_client_1.default.post(nft_constants_1.NFT_API_URLS.LIST_COLLECTED, data);
    };
    NftAPI.fetchNFTsByUser = function (identity, pager) {
        return api_client_1.default.post(nft_constants_1.NFT_API_URLS.GET_NFTS_BY_USER, {
            identity: identity,
            pager: pager
        });
    };
    NftAPI.fetchHistory = function (id, pager) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.GET_HISTORY, { id: id, pager: pager })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.fetchActiveOwners = function (id, pager) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.GET_ACTIVE_OWNERS, { id: id, pager: pager })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.deleteNft = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.DELETE_NFT, { id: id })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.contactOwner = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.CONTACT_OWNER, data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.fetchById = function (id, headers) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.GET_INFO, { id: id }, { headers: headers })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.fetchByIds = function (ids) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.GET_INFO_BY_IDS, { ids: ids })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.update = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.UPDATE, data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.fetchHighLights = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.GET_HIGHLIGHTS, data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.fetchScAddress = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.GET_SC_ADDRESS, { id: id })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.fetchByFilter = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.GET_BY_FILTER, payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.fetchByLaunchpad = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.GET_BY_LAUNCHPAD, payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NftAPI.fetchLockNft = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(nft_constants_1.NFT_API_URLS.LOCK_NFT, payload)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return NftAPI;
}());
exports.NftAPI = NftAPI;
